// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"e01f8c46","413":"e6bafae4","963":"5aeb5a9c"}[chunkId] + ".chunk.js";
};